import { gql } from '@apollo/client'

export const ACCOMMODATION_BOOKING_PERMISSION_QUERY = gql`
  query AccommodationBookingPermission(
    $input: AccommodationBookingPermission!
  ) {
    accommodationBookingPermission(input: $input) {
      accommodationId
      accommodationName
      channelType
      actionType
      allowOperation
      allowDiscount
      allowDiscount
      reservationType
    }
  }
`

export const UPDATE_ACCOMMODATION_BOOKING_PERMISSION_MUTATION = gql`
  mutation UpdateAccommodationBookingPermission(
    $input: [UpdateBookingPermissionInput!]!
  ) {
    updateAccommodationBookingPermission(input: $input) {
      message
    }
  }
`
